import axios from '@/utils/request'

export default {
  // 2020-08-04
  findByFactoryId(factoryId) {
    return axios.get('/mes/user-factories/find-by-factory-id/' + factoryId)
  },
  // 2020-08-04
  insertBatch(params) {
    return axios.post('/mes/user-factories/insert-batch', params)
  },
  // 2020-08-04
  delete(id) {
    return axios.delete('/mes/user-factories/' + id)
  },
  // 2020-12-27
  findByUserId(userId) {
    return axios.get('/mes/user-factories/find-by-user-id/' + userId)
  }
}

